<template>
  <div class="bg">
    <!-- 發佈成功 -->
    <div v-if="userInfo.expire_status" class="publish-success-box">
      <TopUpTip></TopUpTip>
    </div>
    <!-- 發佈全景內容 -->
    <div v-else>
      <!-- 標題 -->
      <div class="title">{{ $t("moduleTitles.pcpublish") }}</div>
      <a-divider />
      <!-- 按鈕 -->
      <div class="chooseBtn">
        <a-button type="primary" @click="addImage">{{
          $t("publish.addlive")
        }}</a-button>
      </div>
      <!-- 顯示列表 -->
      <div class="drag-upload">
        <div class="pl-show-img">
          <div class="item-box" v-for="(item, index) in fileList" :key="index">
            <div class="item-img"><img :src="item.cover == '' ? '/ssr/static/default.png' : item.cover" />
              <div class="item-info">
                <div class="info-data" v-html="item.name"></div>
                <a href="javascript:void(0);" @click.stop="delFile(index, item.id)">{{ $t('actionTitles.delete') }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 表單 -->
      <a-form-model>
        <a-row>
          <a-col :span="10">
            <a-form-model-item :label="$t('publish.starttime.label')">
              <a-date-picker v-model="start_time" show-time type="date"
                :placeholder="$t('publish.starttime.placeholder')" style="width: 100%;" :format="format" />
            </a-form-model-item>
          </a-col>
          <a-col :span="4"></a-col>
          <a-col :span="10">
            <a-form-model-item :label="$t('publish.endtime.label')">
              <a-date-picker v-model="end_time" show-time type="date" :placeholder="$t('publish.endtime.placeholder')"
                style="width: 100%;" :format="format" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <!-- 作品名稱 -->
        <a-row>
          <a-col :span="10">
            <a-form-model-item :label="$t('publish.workName.label')">
              <a-input :placeholder="$t('publish.workName.placeholder')" v-model="publishName" />
            </a-form-model-item>
          </a-col>
          <a-col :span="4"></a-col>
          <!-- 作品行業 -->
          <a-col :span="10">
            <a-form-model-item :label="$t('publish.industry.label')">
              <a-select v-model="selectedIndustry" :placeholder="$t('publish.industry.placeholder')">
                <a-select-option :key="industry.id" :value="industry.id" v-for="industry in industryData">{{ industry.name
                }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row>
          <!-- 客戶姓名 -->
          <a-col :span="10">
            <a-form-model-item :label="$t('publish.customerName.label')">
              <a-input :placeholder="$t('publish.customerName.placeholder')" v-model="customer_name" />
            </a-form-model-item>
          </a-col>
          <a-col :span="4"></a-col>
          <!-- 客戶電話 -->
          <a-col :span="10">
            <a-form-model-item :label="$t('publish.customerTel.label')">
              <a-input :placeholder="$t('publish.customerTel.placeholder')" v-model="customer_phone" />
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row>
          <!-- 作品分類 -->
          <a-col :span="10">
            <a-form-model-item :label="$t('publish.workCategory.label')">
              <a-tree-select :placeholder="$t('publish.workCategory.placeholder')" style="width: 100%"
                v-model="selectedCate" :replaceFields="{
                  children: 'children',
                  title: 'name',
                  key: 'id',
                  value: 'id',
                }" :tree-data="cateTree" tree-default-expand-all></a-tree-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="4"></a-col>
          <!-- 作品地區 -->
          <a-col :span="10">
            <a-form-model-item :label="$t('publish.workRegion.label')">
              <HRegionSelect @regionData="getRegionData"></HRegionSelect>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row>
          <!-- 作品標籤 -->
          <a-col :span="10">
            <a-form-model-item :label="$t('publish.workTag.label')">
              <CTagSelect :type="2" @updateTagData="updateTagData"></CTagSelect>
            </a-form-model-item>
          </a-col>
          <a-col :span="4"></a-col>
          <!-- 保存位置 -->
          <a-col :span="10">
            <a-form-model-item :label="$t('publish.savePath.label')">
              <div style="width: 100%; position: relative">
                <a-input :placeholder="$t('publish.savePath.placeholder')" v-model="dir_name">
                  <a-icon slot="suffix" style="
                      color: rgba(0, 0, 0, 0.25);
                      fontsize: 12px;
                      width: 12px;
                      height: 12px;
                    " type="down" />
                </a-input>
                <div @click="onClickDirSelect" style="
                    position: absolute;
                    top: 0;
                    left: 0;
                    bottom: 0;
                    right: 0;
                  "></div>
              </div>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="10">
            <!-- 是否公開 -->
            <a-col :span="12">
              <a-form-model-item :label="$t('publish.isPublic')">
                <a-radio-group name="radioGroup" :default-value="1" @change="radioChange">
                  <a-radio :value="1">{{ $t("publish.public") }}</a-radio>
                  <a-radio :value="0">{{ $t("publish.pravite") }}</a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
          </a-col>
          <a-col :span="4"></a-col>
          <!-- 詳細地址 -->
          <a-col :span="10">
            <a-form-model-item :label="$t('publish.address.label')">
              <a-input :placeholder="$t('publish.address.placeholder')" v-model="detail_address" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <!-- 作品介紹 -->
        <a-row>
          <a-form-model-item has-feedback :label="$t('publish.pDescription')">
            <editor v-model="brief" @changeEditor="changeEditor"></editor>
          </a-form-model-item>
        </a-row>
      </a-form-model>

      <a-divider />

      <a-button type="primary" :disabled="isUploading" @click="clickToPublish">
        {{ $t("publish.publish") }}
      </a-button>
    </div>
    <HMaterialModal :visible="materialVisible" ref="material" @close="materialVisible = false"
      @handleConfirm="materialConfirm"></HMaterialModal>
    <!--目錄-->
    <a-modal v-model="treeVisible" :title="$t('actionTitles.moveTo')" :ok-text="$t('actionTitles.save')"
      :cancel-text="$t('actionTitles.cancel')" @ok="confirm">
      <a-directory-tree :replaceFields="{ children: 'children', title: 'name', key: 'id' }" :load-data="onLoadData"
        :tree-data="treeData" :selectedKeys="selectedKeys" @select="onSelect" />
    </a-modal>
  </div>
</template>

<script>
import TopUpTip from "@/components/TopUpTip";
import { mapGetters } from "vuex";
import { getIndustry, publishVRImg } from "@/api/publish";
import { getTree as getCateTree } from "@/api/cate";
import HRegionSelect from "@/components/HRegionSelect";
import CTagSelect from "@/components/Tag";
import HMaterialModal from "@/components/HMaterialModal";
import MaterialSelect from "@/components/MaterialSelect";
import { getTreeDir } from "@/api/work";
import DragUploader from "@/components/DragUploader";
import Editor from "@/components/Editor";
import moment from 'moment';

export default {
  components: {
    TopUpTip,
    HRegionSelect,
    CTagSelect,
    HMaterialModal,
    MaterialSelect,
    DragUploader,
    Editor
  },
  data() {
    return {
      // 按鈕
      materialVisible: false,
      // 表單
      start_time: "",
      end_time: "",
      publishName: "",
      selectedIndustry: undefined,
      industryData: [],
      customer_name: "",
      customer_phone: "",
      selectedCate: undefined,
      cateTree: [],
      finalRegionId: "",
      dir_name: this.$t("moduleTitles.root"),
      selectedTags: [],
      treeVisible: false,
      isPuplic: 1,
      isWater: 0,
      detail_address: "",
      isUploading: false,
      fileList: [],
      dateFormat: 'YYYY/MM/DD',
      dir_id: 0,
      brief: "",

      treeData: [{ id: 0, name: this.$t("moduleTitles.root") }],
      selectedKeys: [],
      format: 'YYYY-MM-DD HH:mm:ss'

    }
  },
  created() {
    this.$store.dispatch("getUserInfo"); //更新用戶的配置
    getIndustry().then((res) => {
      this.industryData = res.data;
    });
    getCateTree().then((res) => {
      this.cateTree = res.data;
      if (this.cateTree.length > 0) {
        // 默認選擇第一個
        this.selectedCate = this.cateTree[0].id;
      }
    });
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    // 按鈕
    addImage() {
      this.materialVisible = true;
    },
    // 作品地區
    getRegionData(result) {
      this.finalRegionId = result;
    },
    // 作品標籤
    updateTagData(data) {
      this.selectedTags = data;
    },
    // 保存位置
    onClickDirSelect() {
      this.treeVisible = true;
    },
    // 是否公開
    radioChange(e) {
      this.isPuplic = e.target.value;
    },
    // 作品介紹
    changeEditor(content) {
      this.brief = content;
    },
    // 圖片保護
    waterradioChange(e) {
      this.isWater = e.target.value;
    },
    onSelect(selectedKeys, info) {
      this.selectedKeys = selectedKeys;
      this.selectedName = info.node.dataRef.name;
    },
    // 目錄
    confirm() {
      if (this.selectedKeys.length <= 0) {
        this.$message.warning(this.$t("message.selectPath"));
        return;
      }
      this.dir_id = this.selectedKeys[0];
      this.dir_name = this.selectedName;
      this.treeVisible = false;
    },
    onLoadData(treeNode) {
      return new Promise((resolve, reject) => {
        if (treeNode.dataRef.children) {
          resolve();
          return;
        }
        getTreeDir({ pid: treeNode.dataRef.id }).then((res) => {
          if (res.code && res.data.length > 0) {
            treeNode.dataRef.children = res.data;
          } else {
            treeNode.dataRef.isLeaf = true;
          }
          this.treeData = [...this.treeData];
          resolve();
        });
      });
    },
    // 發佈全景
    clickToPublish() {
      this.start_time && (this.start_time = moment(this.start_time).format(this.format));
      this.end_time && (this.end_time = moment(this.end_time).format(this.format));
      const { panolive } = this.handlefileList(
        this.fileList
      );
      let params = {
        panolive: panolive,
        start_time: this.start_time,
        end_time: this.end_time,
        name: this.publishName,
        industry: this.selectedIndustry,
        cate: this.selectedCate,
        region: this.finalRegionId,
        pic_tags: this.selectedTags,
        is_public: this.isPuplic,
        dir_id: this.dir_id,
        dir_name: this.dir_name,
        detail_address: this.detail_address,
        customer_phone: this.customer_phone,
        customer_name: this.customer_name,
        brief: this.brief,
      };
      if (params.start_time === "") {
        this.$message.error(this.$t("publish.starttime.message"));
        return;
      }
      if (params.end_time === "") {
        this.$message.error(this.$t("publish.endtime.message"));
        return;
      }
      if (params.name === "") {
        this.$message.error(this.$t("publish.workName.message"));
        return;
      }
      if (!params.industry) {
        this.$message.error(this.$t("publish.industry.message"));
        return;
      }
      if (params.cate === "") {
        this.$message.error(this.$t("publish.workCategory.message"));
        return;
      }
      if (params.region === "") {
        this.$message.error(this.$t("publish.workRegion.message"));
        return;
      }
      if (params.pic_tags.length === 0) {
        this.$message.error(this.$t("publish.workTag.message"));
        return;
      }
      if (params.customer_name === "") {
        this.$message.error(this.$t("publish.customerName.message"));
        return;
      }
      if (params.customer_phone === "") {
        this.$message.error(this.$t("publish.customerTel.message"));
        return;
      }
      if (params.detail_address === "") {
        this.$message.error(this.$t("publish.address.message"));
        return;
      }
      if (params.dir_id === "") {
        this.$message.error(this.$t("publish.savePath.message"));
        return;
      }
      this.$message.loading({
        content: " ",
        key: this.loadingKey,
      });
      let isError = false;
      if (params.panolive.length) {
        publishVRImg(params)
          .then((res) => {
            if (res.code === 1) {
              this.$message.success({
                content: this.$t("publish.publishSuccess"),
                key: this.loadingKey,
                duration: 2,
              });
              this.jumpToPage();
            }
          })
          .catch((err) => {
            isError = true;
          });
      } else {
        publishVRImg(params)
          .then((res) => { })
          .catch((err) => {
            isError = true;
          });
        setTimeout(() => {
          if (isError) return;
          this.$message.success({
            content: this.$t("publish.publishSuccess"),
            key: this.loadingKey,
            duration: 2,
          });
          this.jumpToPage();
        }, 1000);
      }
    },

    jumpToPage() {
      this.$router.push("/member/work/list")
    },
    // 老的文件上傳完畢後的處理方法
    handlefileList(list) {
      console.log(list);
      let panolive = [];
      if (list && list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          const item = list[i];
          panolive.push({
            id: item.id,
            name: item.name,
            cover: item.cover,
          });
        }
      }
      return { panolive };
    },

    materialConfirm(list) {
      let materialList = list.map((item) => {
        if (this.materialVisible) {

          item.name = item.name;
        }
        return item;
      });
      let selectedList = [];
      if (this.fileList.length) {
        materialList.forEach((item) => {
          if (
            !this.fileList.some(
              (value) => value.id === item.id
            )
          ) {
            selectedList.push(item);
          }
        });
      } else {
        selectedList = materialList;
      }

      this.materialVisible = false;
      this.fileList = selectedList;
    },
    // 刪除直播機位
    delFile(index, id) {
      this.fileList.splice(index, 1);
    },
    //回調方法，up為上傳實例對像
    // getUploader: function (up) {
    //   let _this = this;
    //   _this.$nextTick(() => {
    //     up.bind("UploadComplete", function (up, file) {
    //       _this.form.avatar = _this.$refs.uploader.fileList[0].url;
    //     });
    //   });
    // },
  }

}
</script>

<style lang="less" scoped>
.bg {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  padding: 20px 30px;
}

.publish-success-box {
  height: calc(100vh - 150px);
  display: flex;
  justify-content: center;
  align-items: center;
}

.publish-title {
  font-size: 14px;
  color: #000000;
}

.drag-upload {
  margin-bottom: 20px;
  margin-top: 24px;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.02);
}

.options-item {
  flex: 0 0 40%;
}

.tag {
  display: flex;
  justify-content: space-between;
}

.radio {
  margin-top: 24px;
}

.tag-content {
  width: 300px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.chooseBtn .ant-btn {
  margin-right: 15px;
}

.item-img>img {
  margin-right: 15px;
  width: 80px;
  height: 80px;
  flex-shrink: 0;
  color: #fff;
  text-align: center;
  line-height: 80px;
  background: #333;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: auto 100%;
}

.item-img {
  display: flex;
  flex-wrap: wrap;
}

.pl-show-img .item-info .info-data {
  word-wrap: break-word;
  word-break: break-all;
  height: 45px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.info-data {
  margin-bottom: 30px;
}

.specialBtn {
  background-color: #7101ad;
  border-color: #7101ad;
}
</style>